import FileSaver from 'file-saver';

function triggerBrowserDownload(url, fileName) {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener noreferrer';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => document.body.removeChild(a), 0);
}

/**
 *
 * @param file
 * @param type
 * @return {*}
 */
export function downloadFile(file, fileName, type = 'url') {
  if (typeof file === 'undefined' || typeof fileName === 'undefined') return;
  if (type !== 'url' && type !== 'blob') return;

  if (type === 'url') {
    triggerBrowserDownload(file, fileName);
  } else {
    const safeFileName = fileName.replace(/\./g, '_');
    FileSaver.saveAs(file, safeFileName);
  }
}
